import React from 'react';
import Banner from '@hig/banner';

const NotificationBanner = (props) => {
  return (
    <div className="pda-banner">
      <Banner
        type={props.type}
      >
        {props.description}
      </Banner>
    </div>
  )
}

export default NotificationBanner;
